import React from 'react'
import { equals } from '@soltalabs/ramda-extra'
import moment from 'moment'

import { connect } from '@soltalabs/stateless'
import { isFetchingSites$ } from 'modules/ravensdown/site'
import { ForecastModule, forecastStartTimes$ } from 'modules/ravensdown/forecast'

import { ForecastSliderView } from './view'

const Connected = connect(() => ({
  isFetchingSites: isFetchingSites$,
  forecastStartTimes: forecastStartTimes$,
}))(ForecastSlider, equals)

function ForecastSlider({ isFetchingSites, forecastStartTimes }) {
  function onSliderValueChange(e, value) {
    return ForecastModule.updateForecastTime(null, moment.unix(value).toISOString())
  }

  return (
    <ForecastSliderView
      forecastStartTimes={forecastStartTimes}
      onSliderValueChange={onSliderValueChange}
      isLoadingSlider={isFetchingSites}
    />
  )
}

export { Connected as ForecastSlider }
